import { SlateReaderWidget } from '@/components/forms/components/form/reader/widgets/slateReaderWidget';
import { isLockedWidget } from '@/components/forms/utils/links';
import { RichEditor } from '@/components/ui/richEditor';
import { useDynamicProps } from '@/hooks/useDynamicProps';
import type { WidgetWriterProps } from '../widget.type';

type Props = {
  options: {
    withSubject?: boolean;
    withMentions?: boolean;
    subjectRequired?: boolean;
  };
  withSubject?: boolean;
  withMentions?: boolean;
  subjectRequired?: boolean;
} & WidgetWriterProps;

export const SlateWidget = (rjsfProps: Props) => {
  const props = useDynamicProps(rjsfProps);

  // check if the widget is locked because of forms links
  const isLocked = isLockedWidget(props.id, props.formContext?.links);
  // if it is locked redirect to slate reader widget
  if (isLocked) {
    return (
      <div className="max-h-38 min-h-21 overflow-y-auto rounded-sm border border-border px-3 py-2 text-primary opacity-50">
        <SlateReaderWidget
          label={props.label}
          name={props.name}
          value={props.value}
        />
      </div>
    );
  }

  const withSubject = true;
  const withMentions = props.withMentions || props.options?.withMentions;
  const subjectRequired = Boolean(
    props.subjectRequired || props.options?.subjectRequired
  );

  return (
    <RichEditor
      data-cy={`richText-${props.name}`}
      id={props.id}
      onChange={props.onChange}
      placeholder={props.placeholder || 'Enter your comment here.'}
      subjectPlaceholder={props.placeholder || 'Subject'}
      subjectRequired={subjectRequired}
      value={props.value}
      withMentions={withMentions}
      withSubject={withSubject}
      workflowContext={props.formContext?.workflowContext}
    />
  );
};
